export default __webpack_public_path__ + "static/media/fasting_drinks@3x.e8b45ec0.jpg";